<template>
    <modal ref="modal">
        <div id="sub-wrapper">
            <div class="title">{{ kind }}</div>
            <div v-if="live.status === 'started'">
              <div class="watch" v-if="watchableDistributors().length > 0">
                {{ $t('modals.list_distributors.watch.text', { kind: kind }) }}
                <ul>
                  <li v-for="distributor in watchableDistributors()" :key="distributor.id">
                    {{ distributor.label }}
                    <button @click="onWatchClick(distributor)">{{ $t('modals.list_distributors.watch.button') }}</button>
                  </li>
                </ul>
              </div>
            </div>
            <div v-else>
              <div class="add">
                {{ $t('modals.list_distributors.add.text', { kind: kind }) }}
                <button @click="onAddClick">{{ $t('modals.list_distributors.add.button') }}</button>
              </div>
              <div class="remove" v-if="removableDistributors().length > 0">
                {{ $t('modals.list_distributors.remove.text') }}
                <ul>
                  <li v-for="distributor in removableDistributors()" :key="distributor.id">
                    {{ distributor.label }}
                    <button @click="onRemoveClick(distributor.id)">{{ $t('modals.list_distributors.remove.button') }}</button>
                  </li>
                </ul>
              </div>
            </div>
        </div>
    </modal>
</template>

<script>
import distributor from '@/services/distributor'

export default {
  props: {
    distributors: Array,
    live: Object
  },
  data () {
    return {
      kind: '',
      onAdd: null,
      onWatch: null
    }
  },
  methods: {
    show (kind, onAdd, onWatch) {
      this.kind = kind
      this.onAdd = onAdd
      this.onWatch = onWatch
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    },
    removableDistributors () {
      return this.distributors.filter(distributor => distributor.kind === this.kind)
    },
    watchableDistributors () {
      return this.distributors.filter(distributor => distributor.kind === this.kind && distributor.watch_url)
    },
    onAddClick () {
      if (!this.onAdd) return
      this.hide()
      this.onAdd()
    },
    onRemoveClick (distributorId) {
      // Remove distributor
      distributor.remove(distributorId)
        .catch(err => this.$parent.$parent.$parent.$refs.toaster.success(err))
    },
    onWatchClick (distributor) {
      if (!this.onWatch) return
      this.onWatch(distributor)
    }
  }
}
</script>

<style scoped>

#sub-wrapper .title:first-letter {
  text-transform: capitalize;
}

#sub-wrapper .add, #sub-wrapper .remove, #sub-wrapper .watch {
  text-align: left;
}

#sub-wrapper .add, #sub-wrapper .watch {
  margin: 2em 0 0 0;
}

#sub-wrapper .add button {
  display: inline-block;
}

#sub-wrapper .remove {
  margin: 1em 0 0 0;
}

#sub-wrapper ul {
  margin: 1em 0 0 0 ;
  padding: 0 0 0 1em;
}

#sub-wrapper li {
  margin-bottom: 0.5em;
}

#sub-wrapper li:last-child {
  margin-bottom: 0em;
}

</style>
